import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Table } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { XCircleFill } from 'react-bootstrap-icons';
import Flex from 'components/common/Flex';
import Divider from 'components/common/Divider';

const ImportErrorModal = ({ show, onClose, title, errors }) => {
    return (
        <Modal show={show} onHide={onClose} centered size="md" >
            <Modal.Body className="p-4">
                <FalconCloseButton
                    size="sm"
                    className="position-absolute top-0 end-0 me-2 mt-2"
                    onClick={onClose}
                />
                <Flex alignItems="center" className="mb-3">
                    <XCircleFill className="text-danger fs-9 me-2" />
                    <h5 className="mb-0 fs-10 text-danger">{title}</h5>
                </Flex>
                <Divider />
                <div className="table-responsive scrollbar">
                    <Table striped hover size="sm" className="fs-10 mb-0">

                        <tbody>
                            {errors && errors.length > 0 ? (
                                errors.map((error, index) => (
                                    <tr key={index}>
                                        <td className="white-space-nowrap text-danger fw-bold">{`(${error.nationalid})`}</td>
                                        <td className="text-danger">{error.error_msg_en}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2" className="text-center">No details available</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
        </Modal>
    );
};

ImportErrorModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    errors: PropTypes.arrayOf(
        PropTypes.shape({
            nationalid: PropTypes.string,
            error_msg_en: PropTypes.string
        })
    )
};

export default ImportErrorModal;
